var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.25C12 10.3211 10.3211 12 8.25 12C6.17893 12 4.5 10.3211 4.5 8.25C4.5 6.17893 6.17893 4.5 8.25 4.5C10.3211 4.5 12 6.17893 12 8.25ZM9.9 8.25C9.9 9.16127 9.16127 9.9 8.25 9.9C7.33873 9.9 6.6 9.16127 6.6 8.25C6.6 7.33873 7.33873 6.6 8.25 6.6C9.16127 6.6 9.9 7.33873 9.9 8.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 9C19.5 10.6569 18.1569 12 16.5 12C14.8431 12 13.5 10.6569 13.5 9C13.5 7.34315 14.8431 6 16.5 6C18.1569 6 19.5 7.34315 19.5 9ZM17.7 9C17.7 9.66274 17.1627 10.2 16.5 10.2C15.8373 10.2 15.3 9.66274 15.3 9C15.3 8.33726 15.8373 7.8 16.5 7.8C17.1627 7.8 17.7 8.33726 17.7 9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16277 14.9883C3.742 17.5821 5.80002 19.5 8.25 19.5C10.7 19.5 12.758 17.5821 13.3372 14.9883C13.5178 14.1798 12.8284 13.5 12 13.5H4.5C3.67157 13.5 2.98222 14.1798 3.16277 14.9883ZM10.9032 15.6C10.2988 16.7652 9.24693 17.4 8.25 17.4C7.25307 17.4 6.2012 16.7652 5.59675 15.6H10.9032Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0288 15.4936C18.5872 16.7164 17.3886 17.5909 15.9823 17.5909C15.4398 17.5909 15 18.0183 15 18.5455C15 19.0726 15.4398 19.5 15.9823 19.5C18.2563 19.5 20.1864 18.0801 20.8898 16.1058C21.146 15.3867 20.9319 14.6937 20.4906 14.2181C20.0671 13.7615 19.4406 13.5 18.7889 13.5H15.9823C15.4398 13.5 15 13.9274 15 14.4545C15 14.9817 15.4398 15.4091 15.9823 15.4091H18.7889C18.9093 15.4091 18.9946 15.4587 19.0288 15.4936Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.70d43320edde6504341db2d48424cfb6.svg";
export { ForwardRef as ReactComponent };